'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isEmpty } from 'underscore';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { FloatingButtonGroup } from 'foundations-components/transitional/components/FloatingButtonGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FormFieldFloatingButtonGroup extends PureComponent {
  getLangKey(path) {
    return `editor.form.formFields.${path}`;
  }
  maybeRenderSmartButton() {
    const {
      hasDependentFields,
      areDependentFieldsShown,
      isSmartField,
      isRequired,
      isHidden,
      isLegalConsent,
      handleEditDependentFields,
      handleShowQueuedFields,
      handleShowDependentFields,
      handleToggleRequired,
      isMandatory,
      isQueuedField
    } = this.props;
    if (isLegalConsent) {
      return null;
    }
    const buttons = [];
    if (!isMandatory) {
      buttons.push( /*#__PURE__*/_jsx(Button, {
        disabled: isHidden,
        onClick: handleToggleRequired,
        "data-test-id": "floating-more-toggle",
        children: isRequired ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.getLangKey('dependentFields.toggleRequired.optional')
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.getLangKey('dependentFields.toggleRequired.required')
        })
      }, buttons.length));
    }
    if (hasDependentFields) {
      buttons.push( /*#__PURE__*/_jsx(Button, {
        onClick: handleShowDependentFields,
        children: areDependentFieldsShown ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.getLangKey('dependentFields.hide')
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.getLangKey('dependentFields.show')
        })
      }, buttons.length));
      buttons.push( /*#__PURE__*/_jsx(Button, {
        onClick: handleEditDependentFields,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.getLangKey('dependentFields.edit')
        })
      }, buttons.length));
    }
    if (isSmartField && !isQueuedField) {
      buttons.push( /*#__PURE__*/_jsx(Button, {
        onClick: handleShowQueuedFields,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.getLangKey('seeProgressiveProfilingFields')
        })
      }, buttons.length));
    }
    return !isEmpty(buttons) ? /*#__PURE__*/_jsx(Dropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: this.getLangKey('actions')
      }),
      children: /*#__PURE__*/_jsx(List, {
        children: buttons.map(button => /*#__PURE__*/_jsx(ListItem, {
          children: button
        }, button.key))
      })
    }) : null;
  }
  maybeRenderDeleteButton() {
    const {
      isRemovable,
      handleDelete,
      isUsedInRouting,
      isDependentFieldUsedInRouting
    } = this.props;
    const deleteButtonDisabled = isUsedInRouting || isDependentFieldUsedInRouting;
    if (!isRemovable) {
      return null;
    }
    const renderTooltip = () => {
      if (isUsedInRouting) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.formFields.usedInRedirectToASchedulingPage"
        });
      }
      if (isDependentFieldUsedInRouting) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.formFields.usedInRedirectToASchedulingPageDependent"
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: this.getLangKey('delete')
      });
    };
    return /*#__PURE__*/_jsx(IconButton, {
      onClick: handleDelete,
      "data-test-id": "floating-delete",
      tooltip: renderTooltip(),
      disabled: deleteButtonDisabled,
      children: /*#__PURE__*/_jsx(DeleteIcon, {
        size: "100"
      })
    });
  }
  render() {
    const {
      children,
      handleEdit
    } = this.props;
    return /*#__PURE__*/_jsx(FloatingButtonGroup, {
      buttonGroup: /*#__PURE__*/_jsxs(ButtonGroup, {
        zIndex: 2,
        children: [/*#__PURE__*/_jsx(IconButton, {
          onClick: handleEdit,
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: this.getLangKey('edit')
          }),
          children: /*#__PURE__*/_jsx(EditIcon, {
            size: "100"
          })
        }), this.maybeRenderDeleteButton(), this.maybeRenderSmartButton()]
      }),
      children: children
    });
  }
}
FormFieldFloatingButtonGroup.propTypes = {
  hasDependentFields: PropTypes.bool.isRequired,
  areDependentFieldsShown: PropTypes.bool.isRequired,
  isSmartField: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool.isRequired,
  isHidden: PropTypes.bool.isRequired,
  isUsedInRouting: PropTypes.bool.isRequired,
  isDependentFieldUsedInRouting: PropTypes.bool.isRequired,
  isMandatory: PropTypes.bool,
  isRemovable: PropTypes.bool,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleEditDependentFields: PropTypes.func.isRequired,
  handleShowDependentFields: PropTypes.func.isRequired,
  handleShowQueuedFields: PropTypes.func.isRequired,
  handleToggleRequired: PropTypes.func.isRequired,
  isLegalConsent: PropTypes.bool,
  isQueuedField: PropTypes.bool,
  children: PropTypes.node.isRequired
};